import { createSlice } from '@reduxjs/toolkit';
import { fetchAddresses, fetchCountry, fetchStates, setUserSelectedAddress, storeAddress, removeAddress, updateAddress } from '../actions/addressActions'

const AddressReducers = createSlice({
    name: 'AddressReducers',
    initialState: {
        loader: false,
        errors: null,
        addresses: [],
        newAddress: {},
        selectedAddress: {},
        countries: [],
        states: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            /**
             * ADDRESSES
             */
            .addCase(fetchAddresses.pending, (state) => {
                state.loader = true;
                state.errors = null; // Clear any existing errors
            })
            .addCase(fetchAddresses.fulfilled, (state, action) => {
                state.loader = false;
                state.addresses = action.payload; // Store the fetched addresses
            })
            .addCase(fetchAddresses.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload; // Set the error message if the request failed
            })

            /**
             * SET Address
             */
            .addCase(setUserSelectedAddress.pending, (state) => {
                state.loader = true;
                state.errors = null; // Clear any existing errors
            })
            .addCase(setUserSelectedAddress.fulfilled, (state, action) => {
                state.loader = false;
                state.selectedAddress = action.payload; // Store the fetched addresses
            })
            .addCase(setUserSelectedAddress.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload; // Set the error message if the request failed
            })
            /**
             * Store Address
             */
            .addCase(storeAddress.pending, (state) => {
                state.loader = true;
                state.errors = null;
            })
            .addCase(storeAddress.fulfilled, (state, action) => {
                state.loader = false;
                state.newAddress = action.payload;
            })
            .addCase(storeAddress.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload;
            })

            /**
             * REMOVE ADDRESS
             */
            .addCase(removeAddress.pending, (state) => {
                state.loader = true;
                state.errors = null;
            })
            .addCase(removeAddress.fulfilled, (state, action) => {
                state.loader = false;
                state.addresses = state.addresses.filter(address => address.id !== action.payload.address_id);
            })
            .addCase(removeAddress.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload;
            })

            /**
             * UPDATE ADDRESS
             */
            .addCase(updateAddress.pending, (state) => {
                state.loader = true;
                state.errors = null;
            })
            .addCase(updateAddress.fulfilled, (state, action) => {
                state.loader = false;
                state.addresses = state.addresses.map(address =>
                    address.id === action.payload.data.id ? { ...address, ...action.payload.data } : address
                );
            })
            .addCase(updateAddress.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload;
            })

            /**
             * COUNTRIES
             */
            .addCase(fetchCountry.pending, (state) => {
                state.loader = true;
                state.errors = null; // Clear any existing errors
            })
            .addCase(fetchCountry.fulfilled, (state, action) => {
                state.loader = false;
                state.countries = action.payload; // Store the fetched addresses
            })
            .addCase(fetchCountry.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload; // Set the error message if the request failed
            })

            /**
             * STATES
             */
            .addCase(fetchStates.pending, (state) => {
                state.loader = true;
                state.errors = null; // Clear any existing errors
            })
            .addCase(fetchStates.fulfilled, (state, action) => {
                state.loader = false;
                state.states = action.payload; // Store the fetched addresses
            })
            .addCase(fetchStates.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload; // Set the error message if the request failed
            })
    }
})

export default AddressReducers.reducer